import { Controller } from "stimulus";

export default class extends Controller {
  connect() {
    this.disableWith = "Downloading...";
    this.enableWith = this.element.firstChild.value;
    this.buttonElement = this.element.querySelector("[type=submit]");
    this.method = this.element.method.toUpperCase();
    this.url = this.element.action;
  }

  downloadFile(event) {
    event.preventDefault();
    this.disableButton();
    this.submit().finally(() => {
      this.enableButton();
    });
  }

  disableButton() {
    this.buttonElement.disabled = true;
    this.buttonElement.value = this.disableWith;
  }

  enableButton() {
    this.buttonElement.disabled = false;
    this.buttonElement.value = this.enableWith;
  }

  submit() {
    return fetch(this.url, {
      method: this.method,
      body: new FormData(this.element),
    })
      .then((response) => {
        if (response.ok) {
          this.enableButton();

          // Example of Content-Disposition header:
          // "attachment; filename="FILENAME_FROM_SERVER_WITH_EXTENSION".
          // We're extracting the filename using a named capturing group
          var rgex = /filename="(?<filename>.+)"/g;
          var filename = rgex.exec(response.headers.get("Content-Disposition")).groups.filename;

          return Promise.all([response.blob(), filename]);
        }
      })
      .then(([blob, filename]) => {
        if (blob) {
          this.downloadBlob(blob, filename);
        }
      });
  }

  downloadBlob(blob, name = "") {
    // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
    const blobUrl = URL.createObjectURL(blob);

    // Create a link element
    const link = document.createElement("a");

    // Set link's href to point to the Blob URL
    link.href = blobUrl;
    link.download = name;

    // Append link to the body
    document.body.appendChild(link);

    // Dispatch click event on the link
    // This is necessary as link.click() does not work on the latest firefox
    link.dispatchEvent(
      new MouseEvent("click", {
        bubbles: true,
        cancelable: true,
        view: window,
      })
    );

    // Remove link from body
    document.body.removeChild(link);
  }
}
